import { render, staticRenderFns } from "./OrderNew.vue?vue&type=template&id=b4e9c3a2&scoped=true&"
import script from "./OrderNew.vue?vue&type=script&lang=ts&"
export * from "./OrderNew.vue?vue&type=script&lang=ts&"
import style0 from "./OrderNew.vue?vue&type=style&index=0&id=b4e9c3a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e9c3a2",
  null
  
)

export default component.exports